import React from 'react';
import { Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

/**
 * Cadre générique des confirmations (campagne, commande ou toute autre action
 * volontaire) : bandeau ambre signalant qu'une validation est attendue.
 * Le contenu à confirmer est passé en `children`.
 */
const PanneauConfirmation = ({ titre, sousTitre, libelleBouton, chargement, onConfirmer, children }) => (
  <section className="rounded-xl border border-amber-200 bg-amber-50 p-4 sm:p-5" aria-live="polite">
    <div className="mb-3 flex items-start gap-3">
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700" aria-hidden="true">
        <CheckCircleOutlined />
      </div>
      <div>
        <h2 className="text-sm font-semibold text-amber-900">{titre}</h2>
        {sousTitre && <p className="text-xs text-amber-800/80">{sousTitre}</p>}
      </div>
    </div>
    <div className="rounded-lg border border-amber-200/70 bg-white p-3 text-sm text-gray-800">{children}</div>
    <div className="mt-3 flex justify-end">
      <Button type="primary" icon={<CheckCircleOutlined />} loading={chargement} onClick={onConfirmer}>
        {libelleBouton}
      </Button>
    </div>
  </section>
);

export default PanneauConfirmation;
